// extracted by mini-css-extract-plugin
module.exports = {"offerBanner":"iUnxgixYsIe8Qd_usdMNk","infoTooltip":"_2RC4Iixeim-3ufZv0sYBqt","offerBannerText":"HeaQ9ZiZb7KmA47M5t0sR"};